export const GET_REVIEWS = 'reviews/GET_REVIEWS';
